const BaseError = require('make-error').BaseError;

class TimeoutError extends BaseError {
    constructor(errorMessage = 'Request Timed Out.') {
        super(errorMessage);
        //We probably want to know when this happens, so continue logging as error
        this._isUserError = false;
    }
}

module.exports = TimeoutError;
